export default {
	title: 'Canal del Terminal',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Datos del Canal del Terminal',
		description: 'No se encontraron datos del canal del terminal'
	},
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		projNo: 'Proyecto',
		orgId: 'Organización',
		terminalId: 'ID del Terminal',
		terminalNumber: 'Número del Terminal',
		channel: 'Canal',
		hasSensor: 'Tiene Sensor',
		deviceId: 'Dispositivo',
		sensorName: 'Nombre del Sensor',
		dataType: 'Tipo de Datos',
		dataStatus: 'Estado de los Datos',
		placeholder: {
			projNo: 'Por favor seleccione proyecto',
			orgId: 'Por favor seleccione organización',
			terminalId: 'Por favor ingrese el ID del terminal',
			terminalNumber: 'Por favor ingrese el número del terminal',
			channel: 'Por favor ingrese el canal',
			hasSensor: 'Por favor seleccione si tiene sensor',
			deviceId: 'Por favor seleccione dispositivo',
			sensorName: 'Por favor ingrese el nombre del sensor',
			dataType: 'Por favor seleccione tipo de datos',
			dataStatus: 'Por favor seleccione estado de los datos'
		}
	},
	table: {
		projNo: 'N° de Proyecto',
		orgId: 'Organización',
		terminalId: 'ID del Terminal',
		terminalNumber: 'Número del Terminal',
		channel: 'Canal',
		hasSensor: 'Tiene Sensor',
		deivceName: 'Nombre del Dispositivo',
		sensorName: 'Nombre del Sensor',
		dataType: 'Tipo de Datos',
		dataStatus: 'Estado de los Datos'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	options: {
		hasSensor: {
			yes: 'Sí',
			no: 'No'
		},
		dataType: {
			vibration: 'Vibración',
			tempVibration: 'Temp y Vibración',
			tempVibrationSound: 'Temp, Vibración y Sonido',
			current: 'Corriente',
			speed: 'Velocidad'
		},
		dataStatus: {
			normal: 'Normal',
			abnormal: 'Anormal',
			noData: 'Sin Datos'
		}
	}
}
